import { fileExtension, fileSize, FileSizeThresh } from '@lglp/utils';
import {
  propOr,
  compose,
  defaultTo,
  not,
  allPass,
  propEq,
  anyPass,
} from 'ramda';

import { pathEq } from './compact';

export const VIDEO = 'video';
export const IMAGE = 'image';
export const AUDIO = 'audio';
export const TEXT = 'text';
export const QUOTE = 'quote';

export const linkFileExtension = compose(
  (str) => (str || '').replace('.', ''),
  fileExtension,
  propOr('', 'url')
);

export const linkFileSize = (lang) =>
  compose((s) => fileSize(s, lang, FileSizeThresh.Decimal), propOr(0, 'size'));

export const hasTranscription = compose(
  not,
  anyPass([
    allPass([propEq('length', 1), pathEq('0.text', '')]),
    propEq('length', 0),
  ]),
  defaultTo([])
);
